import { tokens, hairline } from "../tokens";
import type { AccentName } from "../tokens";
import { Label } from "./Label";

interface StatTileProps {
	// Micro cap name of the measure.
	label: string;
	// The measured value. Set in tabular figures so a changing digit does not shift the readout.
	value: number | string;
	// Optional unit or short qualifier trailing the value at reduced emphasis.
	unit?: string;
	// One accent when the number itself carries a state; omitted otherwise (numbers are not decorated).
	accent?: AccentName;
}

// A single measured value with its label. The number is the content; the label is the micro cap voice.
export function StatTile({ label, value, unit, accent }: StatTileProps) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: tokens.space.sm,
				background: tokens.color.surface.raised,
				border: hairline(tokens.color.stroke.hairline),
				borderRadius: tokens.radius.lg,
				padding: tokens.space.lg,
			}}
		>
			<Label>{label}</Label>
			<div
				style={{
					...tokens.type.numeric,
					fontFamily: tokens.font.mono,
					fontSize: tokens.size.display,
					fontWeight: tokens.weight.semibold,
					lineHeight: tokens.line.tight,
					color: accent ? tokens.color.accent[accent] : tokens.color.text.primary,
					display: "flex",
					alignItems: "baseline",
					gap: tokens.space.sm,
				}}
			>
				<span>{value}</span>
				{unit && (
					<span style={{ fontSize: tokens.size.body, color: tokens.color.text.muted }}>{unit}</span>
				)}
			</div>
		</div>
	);
}
